import React from "react";
import { Box, FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { Button, Modal } from "@familyzone/component-library";
import FlexibleTable from "../../modules/FlexibleTable";
import TableCentricPage from "../../modules/TableCentricPage";
import Api from "../../utils/Api";
import DeleteButton from "../../modules/DeleteButton";
import PageWithHeader from "../templates/PageWithHeader";

class AddException extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      macAddress: "",
    };
  }

  handleHide = () => {
    this.setState({
      macAddress: "",
      invalidMacIpValueMsg: null,
    });
    this.props.handleClose();
  };

  handle_ChangeMacAddress = (event) => {
    const valueError = this.props.macIpValueValidator(event.target.value);
    this.setState({ macAddress: event.target.value, invalidMacIpValueMsg: valueError });
  };

  is_disabled = () => this.state.invalidMacIpValueMsg || !this.state.macAddress;

  handle_Submit = (event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (!this.is_disabled()) {
      this.props.handleAdd({ macAddress: this.state.macAddress });
      this.handleHide();
    }
  };

  render() {
    return (
      <Modal
        headerText="Add Exception"
        isOpen={this.props.visible}
        size="md"
        onClose={this.handleHide}
        primaryCTALabel="Add"
        primaryCTADisabled={this.is_disabled()}
        onPrimaryCTAClick={this.handle_Submit}
        secondaryCTALabel="Cancel"
        onSecondaryCTAClick={this.handleHide}
      >
        <Box mt="sp16">
          <FormControl isInvalid={!!this.state.invalidMacIpValueMsg}>
            <FormLabel>Mac Address</FormLabel>
            <Input onChange={this.handle_ChangeMacAddress} value={this.state.macAddress} />
            <FormErrorMessage fontWeight="regular">{this.state.invalidMacIpValueMsg}</FormErrorMessage>
          </FormControl>
        </Box>
      </Modal>
    );
  }
}

export default class Exceptions extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      exceptions: [],
      visible__add_exception: false,
      loaded: false,
    };

    this.handle_load();
  }

  handle_load = () => {
    const self = this;
    Api.get("/config/ajax/sessions/exceptions", function (result) {
      const exceptions = result["data"];
      self.setState({
        exceptions: exceptions,
        loaded: true,
      });
    });
  };

  handler__clickAdd = () => {
    this.setState({
      visible__add_exceptions: true,
    });
  };

  handler__clickCloseAdd = () => {
    this.setState({
      visible__add_exceptions: false,
    });
  };

  handle_Delete = (entity) => {
    const self = this;
    Api.delete("/config/ajax/sessions/exceptions", { macAddress: entity }, function () {
      self.handle_load();
    });
  };

  handle__AddException = (entity) => {
    const self = this;
    Api.put("/config/ajax/sessions/exceptions", entity, function () {
      self.handle_load();
    });
  };

  macIpValueValidator = (value) => {
    let errorMsg = null;

    if (this.state.exceptions.some((entry) => entry === value)) {
      errorMsg = "This Mac/IP Address is already in use";
    }

    return errorMsg;
  };

  render__content = () => {
    const self = this;
    const columns = [
      {
        title: "Mac Address",
        data: function (row) {
          return row;
        },
        sortable: (rowA, rowB) => {
          return FlexibleTable.sort_caseinsensitive_strings(rowA, rowB);
        },
        search: FlexibleTable.search__single_string_field(),
        onclick: undefined,
      },
      {
        title: "Operations",
        data: function (row) {
          return (
            <div>
              <DeleteButton onClick={() => self.handle_Delete(row)}></DeleteButton>
            </div>
          );
        },
        onclick: undefined,
      },
    ];

    return <FlexibleTable columns={columns} data={this.state.exceptions} loaded={this.state.loaded} />;
  };

  render__buttons = () => {
    return (
      <Button variant="primary" onClick={this.handler__clickAdd}>
        Add Exception
      </Button>
    );
  };

  render() {
    return (
      <PageWithHeader
        title="Associations Exceptions"
        breadcrumbs={[
          { title: "Configuration", url: "/config", isActive: false },
          { title: "Users and Groups", url: "/config/device/userdb", isActive: false },
          { title: "Associations Exceptions", isActive: true },
        ]}
      >
        <Box
          css={{
            ".table-search-box": { margin: 0 },
          }}
        >
          <AddException
            visible={this.state.visible__add_exceptions}
            handleAdd={this.handle__AddException}
            macIpValueValidator={this.macIpValueValidator}
            handleClose={this.handler__clickCloseAdd}
          ></AddException>

          <TableCentricPage buttons={this.render__buttons()} content={this.render__content()} />
        </Box>
      </PageWithHeader>
    );
  }
}
